// src/utils/mentionParser.js

/**
 * Единая точка парсинга @-упоминаний для комментариев и уведомлений.
 *
 * Клиент передаёт только текст; список сотрудников берётся из data.employees,
 * поэтому подставить «произвольного получателя уведомления» нельзя -
 * сравниваем фамилию с реально существующими сотрудниками.
 *
 * Формат: @Фамилия или @Фамилия Имя. Регистр фамилии не важен,
 * токен ограничен первым словом до разделителя.
 */

const TOKEN_BOUNDARY = /[\s,.!?:;()[\]{}"']/;

export function extractMentions(text, employees) {
  if (!text || !Array.isArray(employees) || !employees.length) return [];

  const found = new Set();
  for (const part of String(text).split("@").slice(1)) {
    const token = part.trim().split(TOKEN_BOUNDARY)[0]?.toLowerCase();
    if (!token) continue;
    const emp = employees.find((e) => e.last.toLowerCase() === token);
    if (emp) found.add(emp.id);
  }
  return [...found];
}

export function isMentioned(text, employee) {
  if (!text || !employee) return false;
  return extractMentions(text, [employee]).length > 0;
}

/**
 * Кандидаты для выпадающего меню автодополнения.
 * Фильтрация по подстроке «Фамилия Имя», регистронезависимо.
 *
 * Сортировка - по алфавиту (фамилия, при равенстве - имя),
 * localeCompare с 'ru': «ё» и регистр сортируются по-русски, а не
 * по коду символа. Сортируем до slice(0, limit), иначе топ-8
 * окажется произвольной выборкой из массива.
 *
 * Копия массива обязательна: при пустом запросе matches === employees
 * (та же ссылка на массив из стора), а .sort() мутирует на месте.
 * [...matches] разрывает эту связь - стор не переупорядочивается.
 */
export function filterMentionCandidates(query, employees, limit = 8) {
  if (!Array.isArray(employees)) return [];
  const q = (query || "").trim().toLowerCase();
  const matches = q
    ? employees.filter((e) => `${e.last} ${e.first}`.toLowerCase().includes(q))
    : employees;
  return [...matches]
    .sort((a, b) =>
      `${a.last} ${a.first}`.localeCompare(`${b.last} ${b.first}`, "ru"),
    )
    .slice(0, limit);
}

export function insertMention(text, lastAtIndex, employee) {
  const prefix = text.slice(0, lastAtIndex + 1);
  const suffix = text.slice(lastAtIndex + 1);
  const insert = `${employee.last} ${employee.first}, `;
  return {
    text: prefix + insert + suffix,
    cursor: prefix.length + insert.length,
  };
}
